import LoginPage from "@obsbot/remo-pages/src/LoginPage";
import AccountSettingPage from "@obsbot/remo-pages/src/UserSettingPage/AccountSettingPage";
import RTCSettingPage from "@obsbot/remo-pages/src/UserSettingPage/RTCSettingPage";
import DisplaySettingPage from "@obsbot/remo-pages/src/UserSettingPage/DisplaySettingPage";
import GameoverlaySettingPage from "@obsbot/remo-pages/src/UserSettingPage/GameoverlaySettingPage";
import HotkeySettingPage from "@obsbot/remo-pages/src/UserSettingPage/HotkeySettingPage";
import AddFriendsPage from "@obsbot/remo-pages/src/ChatPage/AddFriendsPage";
import ChannelLayoutWrapper from "@obsbot/remo-pages/src/ChannelPage/ChannelLayoutWrapper";
import ChannelPage from "@obsbot/remo-pages/src/ChannelPage/ChannelOuterPage";
import ChannelRoomPage from "@obsbot/remo-pages/src/ChannelPage/ChannelRoomPage";
import OnlineFriendsPage from "@obsbot/remo-pages/src/ChatPage/OnlineFriendsPage";
import TextChatPage from "@obsbot/remo-pages/src/ChatPage/TextChatPage";
import AllFriendsPage from "@obsbot/remo-pages/src/ChatPage/AllFriendsPage";
import RelationshipPage from "@obsbot/remo-pages/src/ChatPage/RelationshipPage";
import GameoverlayLayoutSettingPage from "@obsbot/remo-pages/src/OverlaySettingPage";
import ChannelInvitePage from "@obsbot/remo-pages/src/ChannelInvitePage";
import SoftwareVersionPage from "@obsbot/remo-pages/src/UserSettingPage/SoftwareVersion";
import { ComponentType } from "react";

export enum RouteNameType {
    LoginPage = "LoginPage", // 登录页
    AddFriendsPage = "AddFriendsPage", // 首页子路由 - 添加好友(侧边栏的二级菜单) 登录后默认进入该页面
    TextChatPage = "TextChatPage", // 首页子路由 - 私信聊天(侧边栏的二级菜单)
    OnlineFriendsPage = "OnlineFriendsPage", // 首页子路由 - 在线好友(侧边栏的二级菜单)
    AllFriendsPage = "AllFriendsPage", // 首页子路由 - 全部好友(侧边栏的二级菜单)
    RelationshipPage = "RelationshipPage", // 首页子路由 - 关系(侧边栏的二级菜单)
    ChannelPage = "ChannelPage", // 首页子路由 - 频道(渲染二级侧边栏的折叠面板)
    AccountSettingPage = "AccountSettingPage", // 首页子路由 - 账号设置(侧边栏的二级菜单) 点击设置默认进入该页面
    RTCSettingPage = "RTCSettingPage", // 首页子路由 - 音视频设置(侧边栏的二级菜单)
    DisplaySettingPage = "DisplaySettingPage", // 首页子路由 - 显示设置(侧边栏的二级菜单)
    GameOverlaySettingPage = "GameOverlaySettingPage", // 首页子路由 - 游戏覆盖设置(侧边栏的二级菜单)
    HotKeySettingPage = "HotKeySettingPage", // 首页子路由 - 快捷键设置(侧边栏的二级菜单)
    GameOverlaySettingViewPage = "GameOverlaySettingViewPage", // 游戏覆盖布局设置窗口
    ChannelInvitePage = "ChannelInvitePage", // Web端邀请好友加入频道页面(Web端尝试调起App)
    // GameOverlayPage = "GameOverlayPage", // 游戏中覆盖窗口
    SoftwareVersionPage = "SoftwareVersionPage",
}

export const routeConfig = {
    [RouteNameType.LoginPage]: {
        title: "LoginPage",
        path: "/login",
        component: LoginPage,
    },
    // 联系人列表-添加好友
    [RouteNameType.AddFriendsPage]: {
        title: "AddFriendsPage",
        path: "/friends/add-friends",
        component: AddFriendsPage,
    },
    // 频道页面
    [RouteNameType.ChannelPage]: {
        title: "ChannelPageWrapper",
        path: "/channel",
        component: ChannelLayoutWrapper,
        children: [
            {
                title: "ChannelPage",
                path: "",
                component: ChannelPage,
            },
            {
                title: "ChannelRoomPage",
                path: "room/:roomUUID",
                component: ChannelRoomPage,
            },
        ],
    },
    // 联系列表-私信聊天
    [RouteNameType.TextChatPage]: {
        title: "TextChatPage",
        path: "/friends/text-chat/:id/:name",
        component: TextChatPage,
    },
    // 联系列表-在线好友
    [RouteNameType.OnlineFriendsPage]: {
        title: "OnlineFriendsPage",
        path: "/friends/online-friends",
        component: OnlineFriendsPage,
    },
    // 联系列表-全部好友
    [RouteNameType.AllFriendsPage]: {
        title: "AllFriendsPage",
        path: "/friends/all-friends",
        component: AllFriendsPage,
    },
    // 联系列表-关系
    [RouteNameType.RelationshipPage]: {
        title: "RelationshipPage",
        path: "/friends/relationship",
        component: RelationshipPage,
    },
    // 用户设置的页面, 测试配置的submenu是否生效
    [RouteNameType.AccountSettingPage]: {
        title: "AccountSettingPage",
        path: "/setting/account-setting",
        component: AccountSettingPage,
        group: "setting",
    },
    //  音视频设置
    [RouteNameType.RTCSettingPage]: {
        title: "RTCSettingPage",
        path: "/setting/rtc-setting",
        component: RTCSettingPage,
    },
    // 显示设置
    [RouteNameType.DisplaySettingPage]: {
        title: "DisplaySettingPage",
        path: "/setting/display-setting",
        component: DisplaySettingPage,
    },
    // 游戏覆盖设置
    [RouteNameType.GameOverlaySettingPage]: {
        title: "GameOverlaySettingPage",
        path: "/setting/game-overlay-setting",
        component: GameoverlaySettingPage,
    },
    //  快捷键设置
    [RouteNameType.HotKeySettingPage]: {
        title: "HotKeySettingPage",
        path: "/setting/hot-key-setting",
        component: HotkeySettingPage,
    },
    // 游戏覆盖布局设置窗口
    [RouteNameType.GameOverlaySettingViewPage]: {
        title: "GameOverlaySettingViewPage",
        path: "/screen/game-overlay-setting",
        component: GameoverlayLayoutSettingPage,
    },
    // 软件版本页面
    [RouteNameType.SoftwareVersionPage]: {
        title: "SoftwareVersionPage",
        path: "/setting/software-version",
        component: SoftwareVersionPage,
    },
    // Web端邀请好友加入频道页面(Web端尝试调起App)
    [RouteNameType.ChannelInvitePage]: {
        title: "ChannelInvitePage",
        path: "/channel/invite/:roomKey",
        component: ChannelInvitePage,
    },
} as const;

type CheckRouteConfig<
    T extends {
        [name in RouteNameType]: {
            title: string;
            path: string;
            component: ComponentType<any>;
        };
    },
> = T;

export type RouteConfig = CheckRouteConfig<typeof routeConfig>;
